import { useAtom, atom } from 'jotai';
import * as React from 'react';

const scrollPositionAtom = atom<number>(0);

export const useScrollToPreviousPosition = () => {
  const scrollContainerRef = React.useRef<HTMLDivElement>(null);

  const [scrollPosition, setScrollPosition] = useAtom(scrollPositionAtom);

  React.useLayoutEffect(() => {
    const scrollContainer = scrollContainerRef?.current;

    scrollContainer?.scrollBy({ left: 0, top: scrollPosition });

    return () => {
      if (scrollContainer?.scrollTop) {
        setScrollPosition(scrollContainer?.scrollTop);
      }
    };
  }, [scrollPosition, setScrollPosition, scrollContainerRef]);

  return scrollContainerRef;
};
